(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, MATERIA_FORM_ADMIN) {
        var config = MATERIA_FORM_ADMIN();
        var base = "admin/aulaDigital/materia";
        var params = {
            parent: "admin/aulaDigital/nivelEducativo",
            view: 'contentChildren',
            base: base,
            baseUrl: "/{nivelid}/materia",
            translateBase: "aulaDigital.materia.admin.",
            templateList: '<materia-list-admin></materia-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/auladigital/admin/aula-digital-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                nivelEducativo: function ($stateParams, NivelEducativo) {
                    // TODO: ¿Optimizar y obtener sólo ID y nombre?
                    return NivelEducativo.get({id: $stateParams.nivelid}).$promise;
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (Materia, $stateParams) {
                    return Materia.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();
